/**
 * @module linkage/chartTypeSwitch/reconcileForChartType
 * @description QB 顶栏切图时 L2 合法性校正入口；按配置域拆文件，index 注册 pipeline
 */

import { type TChartType } from '@dbl/core/chart';
import type { QBStateSnapshot } from '../../../types';
import { pipeReconcileLayers } from './pipeLayers';
import { reconcileChartSwitchForChartType } from './reconcileChartSwitch';
import { reconcileDataLabelForChartType } from './reconcileDataLabel';
import { reconcileDualAxisForChartType } from './reconcileDualAxis';
import { reconcileSortForChartType } from './reconcileSort';
import type { IReconcileChartTypeResult } from './reconcileTypes';

export type { IReconcileChartTypeResult } from './reconcileTypes';
export type { ISortItemVisibility } from './reconcileSort';
export { resolveSortItemVisibility } from './reconcileSort';

/** 切图 L2 pipeline：新增配置域时在数组末尾追加 reconcileXxxForChartType */
const RECONCILE_LAYERS = [
  reconcileSortForChartType,
  reconcileDualAxisForChartType,
  reconcileChartSwitchForChartType,
  reconcileDataLabelForChartType,
];

/**
 * 切图 L2：依次执行各配置域 reconcile，合并 patch 后返回。
 */
export function reconcileConfigForChartType(
  chartType: TChartType,
  qb: QBStateSnapshot,
  base: Record<string, unknown>,
  draft: Record<string, unknown>,
): IReconcileChartTypeResult {
  return pipeReconcileLayers(
    chartType,
    qb,
    base,
    draft,
    RECONCILE_LAYERS,
  );
}

